<div>
  <div class="dam">
    <div
      class="dam-header"
    >
      <div class="dam__center-block">
        <div class="dam__center-header">
          <app-breadcrumbs controller="/cabinet/dam" param="catalog_id" [breadCrumbs]="catalogBreadCrumbs"/>
          <h4>
            Файлы

            <span class="dam__center-header-count">
            Всего {{ totalElements }} {{ createLabel(totalElements, 'файл|файла|файлов') }}
          </span>
          </h4>
        </div>


        <div class="dam__center-content">
          <app-dam-search-elastic/>

          <app-view-changing-tabs (viewChangeEvent)="showProductBlocks($event)"/>

          <button nbButton size="small" (click)="NewFolderDialog.openDialog()" i18n-nbTooltip="@@CreateFolder" nbTooltip="Создать папку">
            <nb-icon icon="folder-add-outline"/>
          </button>

          <button nbButton size="small" *ngIf="catalogId" [routerLink]="catalogId !== 0 ? ['create', catalogId] : ['create']" i18n-nbTooltip="@@CreateFolder" nbTooltip="Редактировать папку">
            <nb-icon icon="edit-outline"/>
          </button>

          <button nbButton size="small" (click)="MassOperationsDialog.openDialog()">
            <nb-icon icon="layers-outline"/>
            Массовые операции
          </button>

          <button nbButton size="small" (click)="SidebarFiltersDialog.openDialog()">
            <nb-icon icon="options-2-outline"/>
            Все фильтры
            <span class="selected-filters-count" *ngIf="getTotalFiltered()>0">{{ getTotalFiltered() }}</span>
          </button>

          <button nbButton size="small" status="primary" [disabled]="isRootCatalog()" (click)="FileDownloadDialog.openDialog()">
            Загрузить файл
          </button>

          <div class="dam__sort" *ngIf="pagination">
            <nb-select
              placeholder="Сортировка"
              size="small"
              (selectedChange)="changeSort($event)"
              i18n-nbTooltip="@@Sorting"
              nbTooltip="Сортировка"
              [selected]="pagination.order + '-' + pagination.direction"
            >
              <nb-option value="header_asc">Название: A -> Z</nb-option>
              <nb-option value="header_desc">Название: Z -> A</nb-option>
              <nb-option value="createdAt_asc">Старые</nb-option>
              <nb-option value="createdAt_desc">Новые</nb-option>
              <nb-option value="updatedAt_desc">Измененные</nb-option>
            </nb-select>
          </div>
        </div>
      </div>

      <app-dam-filters
        *ngIf="fieldsFeaturesFast"
        [fieldsFeaturesFast]="fieldsFeaturesFast"
        [fieldsFeatures]="fieldsFeatures"
        [formFilterFast]="formFilterFast"
        [optionsFast]="optionsFast"
        [modelFeaturesFast]="modelFeaturesFast"
        [modelFeatures]="modelFeatures"/>
    </div>


    <ng-container
      *ngIf="(productList$ | async) as productList"
    >
      <div class="dam__center" [ngClass]="{'active': productShow}">
        <app-plates-view
          [isShowProductList]="isShowProductList"
          [pagination]="pagination"
          [damElements]="productList"
          [damElements$]="productListSubject"
          (elementClickEventEmitter)="elementClickEventHandler($event)"
          (elementSelectEvent)="onElementSelect($event)"
          (allElementSelectEvent)="onAllElementSelect($event)"
          (elementDownloadEvent)="onElementDownload($event)"
          (elementDeleteEvent)="onElementDelete($event)"
          (elementShareEvent)="onElementShare($event)"
          (elementChangeCatalogEvent)="onElementChangeCatalog($event)"
          [selected$]="selected$"
        >
        </app-plates-view>
      </div>

      <div
        class="dam__right"
        [ngClass]="{'content': true, 'active': productShow}"
      >
        <app-dam-element-preview
          id="dam-element-preview"
          [isOpen]="productShow"
          [_damElement]="damElasticDTO"
          [damItemVersions]="damItemVersionWithDocumentInfo"
          [damItemVersionWithDocumentInfoExtensions]="damItemVersionWithDocumentInfoExtensions"
          [fileExtensions]="damItemVersionWithDocumentInfoExtensionsCount"
          (closeEvent)="closeSidebar()"
        >
        </app-dam-element-preview>
      </div>
    </ng-container>
  </div>
</div>


<app-dialog-wrapper
  #FileDownloadDialog
>
  <app-file-upload>
  </app-file-upload>
</app-dialog-wrapper>

<app-dialog-wrapper
  #MassOperationsDialog
>
  <div
    class="dialog-elements mass-operations"
  >
    <span class="dialog-elements__tittle">
      Массовые операции
    </span>

    <nb-card>
      <nb-card-body>
        <form [formGroup]="formBatch" (ngSubmit)="batchSubmit()">
          <formly-form
            [form]="formBatch"
            [fields]="configBatch.columns"
            [options]="optionsBatch"
            [model]="modelBatch"
          ></formly-form>
          <div
            class="dialog-elements-buttons"
          >
            <button

              type="submit"
              nbButton status="primary"
              i18n="@@Update"
              [disabled]="formBatch.invalid"
            >
              Обновить
            </button>
          </div>
        </form>
      </nb-card-body>
    </nb-card>
  </div>
</app-dialog-wrapper>

<app-dialog-wrapper
  #NewFolderDialog
>
  <div
    class="dialog-elements"
  >
    <span class="dialog-elements__tittle">
      Создать новую папку
    </span>

    <div
      class="dialog-elements-row vertical"
    >
      <span class="dialog-elements-row__tittle">
        Название папки
      </span>

      <input
        placeholder="Название папки" alt=""
        [(ngModel)]="createFolderName"
      >
    </div>

    <div
      class="dialog-elements-buttons"
    >
      <button
        nbButton
        (click)="NewFolderDialog.closeDialog()"
      >
        Отменить
      </button>
      <button
        nbButton status="primary"
        (click)="createFastFolder()"
      >
        Создать папку
      </button>
    </div>
  </div>
</app-dialog-wrapper>

<app-dialog-wrapper
  #UnitDamItemsDialog
>
  <div
    class="dialog-elements"
  >
    <span class="dialog-elements__tittle">
     Объединить элементы
    </span>

    <div
      class="dialog-elements-row"
    >
      <app-dam-unit-items [damItems]="selectedElements"></app-dam-unit-items>
    </div>
  </div>
</app-dialog-wrapper>

<div
  class="control-panel-container"
  [ngClass]="{
    'fade-out': !selected$.value?.size,
    'fade-in': selected$.value?.size,
  }"
>
  <div
    class="selected-elements-control-panel"
  >
    <div class="control-panel-item">
      {{ selected$.value?.size || 0 }} из {{ totalElements }} <span>Выбрано</span>
    </div>
    <a class="control-panel-item" (click)="shareDamItems()">
      <nb-icon icon="share-outline"/>
      Поделиться
    </a>
    <a class="control-panel-item" (click)="downloadDamItems()">
      <nb-icon icon="download-outline"/>
      Скачать
    </a>
    <a
      class="control-panel-item"
      [class.filter-grey-prime]="selected$.value?.size > 1"
      [class.filter-disabled-base]="selected$.value?.size <= 1"
      (click)="unitDamItems()"
    >
      <nb-icon icon="swap-outline"/>
      Объединить
    </a>

    <a class="control-panel-item" (click)="enableDamItems()">
      <nb-icon icon="checkmark-circle-2-outline"/>
      Активировать
    </a>
    <a class="control-panel-item" (click)="approveDamItems()">
      <nb-icon icon="shield-outline"/>
      Одобрить
    </a>

    <a class="control-panel-item filter-white" (click)="deleteDamItems()">
      <nb-icon icon="trash-outline"/>
      Удалить
    </a>
  </div>
</div>

<app-dialog-wrapper
  #SidebarFiltersDialog
  id="SidebarFiltersDialog"
>
  <app-sidebar-filters
    [fieldsFeatures]="fieldsFeatures"
    [formFilter]="formFilter"
    [options]="options"
    [modelFeatures]="modelFeatures"
    [modelFeaturesFast]="modelFeaturesFast"
  >
  </app-sidebar-filters>
</app-dialog-wrapper>

